import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  class: "dashboard-card",
  style: {"overflow":"auto","min-width":"auto"}
}
const _hoisted_3 = { class: "d-flex mb-4 fixed-header px-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", null, "Сравнение отчетов супервайзера", -1)
const _hoisted_5 = { class: "row fixed-header px-6 mt-h" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"100px"} }, null, -1)

import { useAccountStore } from '@/stores/account';
import { useDialogStore } from '@/stores/dialogs';
import { computed, ref, watch } from 'vue';
import { useTrackersStore } from '@/stores/trackers';
import { useProgramsStore } from '@/stores/programs';
import CreateSupervisorReportDialog from '@/components/dialogs/CreateSupervisorReportDialog.vue';
import SupervisingTable from '@/components/SupervisingTable.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'TrackersSupervising',
  props: {
    programId: null
  },
  setup(__props: any) {

const props = __props as { programId?: string }

const accountStore = useAccountStore()
const dialogStore = useDialogStore()
const trackersStore = useTrackersStore()



const addSupervisorReport = () => {
  dialogStore.open(CreateSupervisorReportDialog)
}

const programStore = useProgramsStore()

const currentProgramId = ref<any>(null)
const program = computed<any>(() => {
  const programId = currentProgramId.value
  if (programId) {
    return programStore.programs.find(item => item.id === programId)
  }
  return null
})

watch(program, () => {
  currentTeamId.value = 'all'
  currentSupervisorid.value = 'all'
})

watch(programStore.programs, (arr) => {
  if (arr.length === 0) return
  currentProgramId.value = arr[0].id
}, { immediate: true })

const currentSupervisorid = ref<string>('all')

const currentTeamId = ref<string>('all')

const currentTrackerId = ref<string>('all')

const trackers = computed(() => {
  const arr = Array.from(Object.values(trackersStore.trackers))
  if (!program.value?.teams) return arr
  const trackers = new Set(program.value.teams.map((item: any) => item.trackerId))
  return arr.filter(item => trackers.has(item.id))
})

watch(currentTeamId, (value) => {
  if (!value || value === 'all') return
  currentTrackerId.value = 'all'
})
  
watch(currentTrackerId, (value) => {
  if (!value || value === 'all') return
  currentTeamId.value = 'all'
})
  


return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_unref(accountStore).isDirector && _unref(accountStore).isSupervisor)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 0,
              variant: "flat",
              height: "32",
              class: "ml-auto",
              color: "primary",
              "append-icon": "mdi-plus",
              onClick: addSupervisorReport
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Добавить отчет супервайзера ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_v_select, {
          modelValue: currentProgramId.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentProgramId).value = $event)),
          items: _unref(programStore).programs,
          class: "v-select-min",
          variant: "outlined",
          label: "Программа",
          "item-value": "id",
          "item-title": "name"
        }, null, 8, ["modelValue", "items"]),
        _createVNode(_component_v_select, {
          modelValue: currentTeamId.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentTeamId).value = $event)),
          items: [ { id: 'all', name: 'Все команды' }, ...(_unref(program)?.teams || [])],
          class: "v-select-min",
          variant: "outlined",
          label: "Команда",
          "item-value": "id",
          "item-title": "name"
        }, null, 8, ["modelValue", "items"]),
        _createVNode(_component_v_select, {
          modelValue: currentTrackerId.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((currentTrackerId).value = $event)),
          items: [ { id: 'all', name: 'Все трекеры' }, ..._unref(trackers) ],
          class: "v-select-min",
          variant: "outlined",
          label: "Трекер",
          "item-value": "id",
          "item-title": "name"
        }, null, 8, ["modelValue", "items"]),
        _createVNode(_component_v_select, {
          modelValue: currentSupervisorid.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((currentSupervisorid).value = $event)),
          items: [ { id: 'all', name: 'Все супервайзеры' }, ..._unref(trackersStore).supervisers],
          class: "v-select-min",
          variant: "outlined",
          label: "Супервайзер",
          "item-value": "id",
          "item-title": "name"
        }, null, 8, ["modelValue", "items"])
      ]),
      _hoisted_6,
      _createVNode(SupervisingTable, {
        "program-id": _unref(program)?.id,
        "supervisor-id": currentSupervisorid.value,
        "team-id": currentTeamId.value,
        "tracker-id": currentTrackerId.value
      }, null, 8, ["program-id", "supervisor-id", "team-id", "tracker-id"])
    ])
  ]))
}
}

})